"use client";

import { P } from "@/components/ui/Heading";
import { Link } from "@/i18n/routing";
import { gTagEvents } from "@/lib/gtag";
import Image from "next/image";
import { useCallback, useEffect } from "react";
import { useIntersectionObserver } from "usehooks-ts";
interface OpportunityCardProps {
  text: string;
  image: string;
  link: string;
  index: number;
}

export const OpportunityCard = (props: OpportunityCardProps) => {
  const { index, image, text, link } = props;

  const { ref, isIntersecting } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.9,
  });

  const handleClick = useCallback(() => {
    gTagEvents.selectPromotion({
      creative_name: text,
      creative_slot: index.toString(),
      promotion_id: text,
      promotion_name: text,
    });
  }, [props]);

  useEffect(() => {
    if (isIntersecting) {
      gTagEvents.viewPromotion({
        creative_name: text,
        creative_slot: index.toString(),
        promotion_id: text,
        promotion_name: text,
      });
    }
  }, [isIntersecting, props]);

  return (
    <Link ref={ref} href={link} onClick={handleClick}>
      <div className="relative group cursor-pointer hover:">
        <div className="h-[260px] w-[260px] object-contain">
          <Image
            src={image}
            alt={text}
            fill={true}
            className="!object-cover rounded-lg !overflow-hidden"
            sizes="(max-width: 768px) 80vw, 30vw"
          />
        </div>
        <div className="absolute inset-0 bg-black/30 group-hover:bg-black/50 rounded-xl" />
        <P className="absolute z-30 top-1/2 text-center w-full select-none font-semibold text-base sm:text-xl text-white group-hover:sm:text-2xl transition-all">
          {text}
        </P>
      </div>
    </Link>
  );
};
